import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import {
  IStandardDocumentVersionData,
  IStandardDocumentCategoryData,
} from '../../../../types/order/documents/shared/interfaces';

export interface IAdminDocumentsState {
  documents: { [orderId: string]: IStandardDocumentVersionData[] };
  categories: IStandardDocumentCategoryData[];
  documentsFetchStatus: IFetchStatus;
  documentsError: string | null;
  documentsActionFetchStatus: IFetchStatus;
  documentsActionError: string | null;
  uploadDocumentsFetchStatus: IFetchStatus;
  uploadDocumentsError: string | null;
  editDocumentsFetchStatus: IFetchStatus;
  editDocumentsError: string | null;
  deleteDocumentsFetchStatus: IFetchStatus;
  deleteDocumentsError: string | null;
  documentHistory: { [documentId: string]: IStandardDocumentVersionData[] };
  documentsHistoryFetchStatus: IFetchStatus;
  documentsHistoryError: string | null;
  mergeDocumentsFetchStatus: IFetchStatus;
  mergeDocumentsError: string | null;
  documentDetails: IStandardDocumentVersionData | null;
}

export const adminDocumentsInitialState: IAdminDocumentsState = {
  documents: {},
  categories: [],
  documentsFetchStatus: createDefaultFetch(),
  documentsError: null,
  documentsActionError: null,
  documentsActionFetchStatus: createDefaultFetch(),
  uploadDocumentsError: null,
  uploadDocumentsFetchStatus: createDefaultFetch(),
  editDocumentsError: null,
  editDocumentsFetchStatus: createDefaultFetch(),
  deleteDocumentsError: null,
  deleteDocumentsFetchStatus: createDefaultFetch(),
  documentHistory: {},
  documentsHistoryFetchStatus: createDefaultFetch(),
  documentsHistoryError: null,
  mergeDocumentsFetchStatus: createDefaultFetch(),
  mergeDocumentsError: null,
  documentDetails: null,
};
